import { SagaIterator } from "redux-saga";
import { call, put, takeLatest } from "redux-saga/effects";
import { IResponse } from "../../../../libs/requester/IResponse";
import { requester } from "../../../../libs/requester/requester-axios";
import { setAssignDeleteError, setLoading } from "../../repository/slice";

function* deleteAssignBadgeWorker({ payload }: any): SagaIterator {
  const { id, ...rest } = payload;

  try {
    yield put(setLoading(true));
    const { data, message, isError }: IResponse<any> = yield call(
      requester.post,
      `/api/user-badge/${id}/dis-assign`,
      rest
    );
    if (isError) {
      yield put(setAssignDeleteError(message));
    } else {
      yield put(setAssignDeleteError(null));
    }
  } catch (error) {
    console.error("deleteAssignBadgeWorker: ", error);
  } finally {
    yield put(setLoading(false));
  }
}

export function* deleteAssignBadgeWatcher() {
  yield takeLatest("@saga/DELETE_ASSIGN_BADGE", deleteAssignBadgeWorker);
}
